export default __webpack_public_path__ + "static/1945-d086392072b7e6e5bfbffeae99e603df.gif";